export default "__VITE_ASSET__DHNk22hf__"